import client from "../../../api/client";

export default async function getCities() {
    const response = await client.get("/master/cities");
    return response.data;
}